import axios from "axios";
import { useRef } from "react";

import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import './MyStyles.css';

import Badge from '@mui/material/Badge';
import MailIcon from '@mui/icons-material/Mail';
import AlarmIcon from "@mui/icons-material/Alarm";
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAuth } from '../context/AuthContext';

import { baseUrl, baseimgUrl, userLocation, ipAddress, userName } from './Univ.js';

const formatDateTime = (dateTimeString) => {
  return new Date(dateTimeString).toLocaleString('en-IN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
};

function Header(props) {

const audioRef = useRef(null);
  const [searchString, setsearchString] = useState({ search: '' });
  const { logoutUser } = useAuth();
const [alerts,setAlerts] = useState([]);
const [alertSound,setAlertSound] = useState(false);
  const checkUser = localStorage.getItem('user_login');
  const checkPat = localStorage.getItem('pat_login');
  const pat_id = localStorage.getItem('pat_id');
  const userGroup = localStorage.getItem('userGroup');

  const [tasks, setTasks] = useState([]);
  const [unreadTasks, setUnreadTasks] = useState([]);
  const [activities, setActivities] = useState([]);
  const [reminderTasks, setReminderTasks] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (checkUser === 'true') {
      fetchActivities();
      fetchTasks();
    }
  }, [checkUser]);

  const fetchActivities = () => {
    setIsLoading(true);
    axios
      .get(`${baseUrl}activities/`)
      .then((res) => setActivities(res.data))
      .catch((err) => console.error(err))
      .finally(() => setIsLoading(false));
  };

const prevAlertCount = useRef(0);

useEffect(() => {

  if (checkUser !== "true") return;

  const interval = setInterval(() => {

    axios.get(`${baseUrl}system-alerts/`)
      .then(res => {

        if (res.data.length > prevAlertCount.current) {
          playAlertSound();
        }

        prevAlertCount.current = res.data.length;
        setAlerts(res.data);

      })
      .catch(err => {
        if (err.response && err.response.status === 401) {
          console.log("User not authenticated, stopping alerts polling");
        } else {
          console.log(err);
        }
      });

  }, 5000);

  return () => clearInterval(interval);

}, [checkUser]);

const playAlertSound = () => {

  if (!audioRef.current) {
    audioRef.current = new Audio("/alert.mp3");
    audioRef.current.loop = true;
  }

  audioRef.current.play().catch(err => console.log(err));
};

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];

    const filtered = activities.filter((row) => {
      if (!row.reminder_date) return false;
      const reminderDate = new Date(row.reminder_date).toISOString().split("T")[0];
      return reminderDate === today && row.addedby === userName;
    });

    setReminderTasks(filtered);
  }, [activities]);

  const countReminders = reminderTasks.length;
  const reminderBadgeColor = countReminders > 0 ? "warning" : "default";
  const reminderIconColor = countReminders > 0 ? "error" : "action";

  const fetchTasks = async () => {
    try {
      const response = await axios.get(baseUrl + "get-todo/");
      setTasks(response.data);
    } catch (error) {
      console.error('Error fetching tasks:', error);
    }
  };

  useEffect(() => {
    setUnreadTasks(tasks.filter(row => row.status === 1 && row.addedby === userName));
  }, [tasks]);

  const countUnreadTasks = unreadTasks.length;

const handleLogout = () => {
  setAlerts([]);
  logoutUser();
  window.location.href = '/user-login/';
};
  const linkMap = {
    Accounting: { home: '/account-menu/', menu: '/admin-menu' },
    Cashier: { home: '/cash-menu/', menu: '/admin-menu' },
    Consultant: { home: '/cons-view', menu: '/admin-menu' },
    FrontOffice: { home: '/front-menu/', menu: '/admin-menu' },
    Admin: { home: '/admin-menu', menu: '/' },
    Lab: { home: '/lab-view/', menu: '/admin-menu' },
    LabAdmin: { home: '/lab-view/', menu: '/admin-menu' },
    Radiology: { home: '/inv-view/', menu: '/admin-menu' },
    Hr: { home: '/hrms-menu/', menu: '/admin-menu' },
    Ip: { home: '/ip-menu/', menu: '/admin-menu' },
    Nurse: { home: '/nurse-menu/', menu: '/admin-menu' },
    Pharmacy: { home: '/pharm-menu/', menu: '/admin-menu' },
    PharmacyStore: { home: '/pharm-store/', menu: '/admin-menu' },
    Stores: { home: '/stores-menu/', menu: '/admin-menu' },
    BloodBank: { home: '/blood-bank/', menu: '/admin-menu' },

    Management: { home: '/mis-menu/', menu: '/admin-menu' },
  };

  const links = linkMap[userGroup] || {};

  const handleChange = (event) => {
    setsearchString({
      ...searchString,
      [event.target.name]: event.target.value,
    });
  };

  const searchCourse = () => {
    if (searchString.search !== '') {
      window.location.href = '/emr-details/' + searchString.search;
    }
  };

  const handlePatLogout = () => {
    localStorage.removeItem('pat_login');
    localStorage.removeItem('pat_id');
    localStorage.removeItem('group');
    window.location.href = '/patient-login/';
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark custom-navbar">
      <div className="container">
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarTogglerDemo01"
          aria-controls="navbarTogglerDemo01"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarTogglerDemo01">
          {checkUser === 'true' && (
            <>
              <Link className="navbar-brand" to={links.menu}>MGM DrG HIS</Link>

              <form className="d-none d-md-flex">
                <input
                  name="search"
                  onChange={handleChange}
                  className="form-control me-2"
                  type="search"
                  placeholder="Search by Patient ID for EMR"
                />
                <button onClick={searchCourse} className="btn btn-info" type="button">
                  Search
                </button>
              </form>

              <ul className="navbar-nav ms-auto flex-row align-items-center gap-3">
                <li className="nav-item">
                  <Link className="navbar-brand" to={links.home}>
                    <FontAwesomeIcon icon="fa-solid fa-house-user" size="1x" color="#ffc107" />
                  </Link>
                </li>

                <li className="nav-item">
                  <Badge color={countUnreadTasks > 0 ? "warning" : "default"} badgeContent={countUnreadTasks}>
                    <a href="/todolist">
                      <MailIcon color={countUnreadTasks > 0 ? "error" : "action"} />
                    </a>
                  </Badge>
                </li>
<li className="nav-item">

<Badge
  color={alerts.length > 0 ? "error" : "default"}
  badgeContent={alerts.length}
>

<a href="/alerts" >
  <NotificationsActiveIcon
    color={alerts.length > 0 ? "error" : "action"}
  />
</a>

</Badge>

</li>
                <li className="nav-item">
                  <Badge color={reminderBadgeColor} badgeContent={countReminders}>
                    <a href="/lead-list">
                      <AlarmIcon color={reminderIconColor} />
                    </a>
                  </Badge>
                </li>

                {/* USER DROPDOWN */}
<li className="nav-item dropdown">
  <a
    className="nav-link dropdown-toggle"
    href="#"
    role="button"
    data-bs-toggle="dropdown"
    aria-expanded="false"
  >
    {userName}
  </a>

  <ul className="dropdown-menu dropdown-menu-end">
    <li className="dropdown-item">Welcome: {userName}</li>

    <li>
      <Link className="dropdown-item" to="/admin-menu">
        Menu
      </Link>
    </li>

    <li>
      <Link className="dropdown-item" to="/change-password">
        Change Password
      </Link>
    </li>

    <li>
      <button className="dropdown-item" onClick={handleLogout}>
        Logout
      </button>
    </li>
  </ul>
</li>

              </ul>
            </>
          )}

          {/* PATIENT VIEW */}
          {checkPat === 'true' && userGroup === 'Patient' && (
            <>
              <Link className="navbar-brand" to="/">MGM DrG HIMS</Link>
              <ul className="navbar-nav ms-auto">
                <li className="nav-item">
                  <Link className="nav-link" to="/pat-menu">Home</Link>
                </li>

                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" href="#" data-bs-toggle="dropdown">
                    {pat_id}
                  </a>

                  <ul className="dropdown-menu dropdown-menu-end">
                    <li className="dropdown-item">Welcome: {pat_id}</li>
                    <li><Link className="dropdown-item" to="/">Dashboard</Link></li>
                    <li><button className="dropdown-item" onClick={handlePatLogout}>Logout</button></li>
                  </ul>
                </li>
              </ul>
            </>
          )}

          {!checkUser && !checkPat && (
            <h3 className="text-white text-center">MGM DrG HIMS</h3>
          )}
        </div>
      </div>
    </nav>
  );
}

export { formatDateTime };
export default Header;
